// Values starting with these characters are evaluated as formulas by Excel/LibreOffice (CSV injection).
// See https://owasp.org/www-community/attacks/CSV_Injection
const FORMULA_TRIGGER_CHARS = ["=", "+", "-", "@", "\t", "\r", "\n"];

// Fields containing these characters must be wrapped in double quotes (RFC 4180).
const CSV_QUOTE_REQUIRED_REGEX = /[",\r\n]/;

// Plain numbers such as "-12.5" or "+3" are not formulas and are left intact.
const NUMBER_REGEX = /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/;

export function isFormulaLike(value: unknown): value is string {
  return (
    typeof value === "string" &&
    value.length > 1 &&
    FORMULA_TRIGGER_CHARS.includes(value.charAt(0)) &&
    !NUMBER_REGEX.test(value)
  );
}

// Prefixes formula-like values with a single quote so spreadsheet apps treat them as text.
export function escapeCsvValue<T>(value: T): T | string {
  return isFormulaLike(value) ? `'${value}` : value;
}

// Serializes a value as one CSV field: formula-like values are escaped, and commas, quotes and
// line breaks are quoted so a value can never spill into another cell or row.
export function toCsvField(value: unknown): string {
  if (value === null || value === undefined) return "";
  const field = String(escapeCsvValue(value));
  return CSV_QUOTE_REQUIRED_REGEX.test(field) ? `"${field.replace(/"/g, '""')}"` : field;
}

export function toCsvRow(values: unknown[]): string {
  return values.map(toCsvField).join(",");
}
